<!--
  @description Agent管理
  @author xiehan
  @date 2018/12/18
-->
<template>
  <div class="agentManage agentManage__content">
    <el-form ref="searchForm" :model="searchForm" :inline="true">
      <el-form-item :label="$t('agentManage.siteCode')">
        <g-select v-model="searchForm.siteCode" :list="select_site" :defaultAll="true"></g-select>
      </el-form-item>
      <el-form-item :label="$t('agentManage.group')">
        <g-select v-model="searchForm.group" :list="select_group" :defaultAll="true"></g-select>
      </el-form-item>
      <el-form-item :label="'IP'">
        <el-input v-model="searchForm.ip"></el-input>
      </el-form-item>
      <el-form-item :label="$t('agentManage.status')">
        <g-select v-model="searchForm.status" :list="select_status" :defaultAll="true"></g-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" 
          @click="search"
          v-g-rac="gRac('agentManage_search')"
          v-text="$t('common.search')"></el-button>
      </el-form-item>
    </el-form>
    <el-table-extend
      :data="tData" 
      :head="tHead" 
      :currentChange="tCurrentChange" 
      :sizeChange="tSizeChange" 
      border>
      <template slot="control-column" slot-scope="{data}">
        <el-table-extend-control 
          :control="tableControl" 
          :data="data" 
          :label="$t('common.handle')">
        </el-table-extend-control>
      </template>
    </el-table-extend>
    <!-- 配置弹窗 -->
    <el-dialog :closeOnClickModal="false"
      :title="$t('agentManage.agentConfig')"
      :visible.sync="agentDiaVis"
      width="860px">
      <div class="dia-title" v-text="$t('agentManage.appList')"></div>
      <el-table
        :data="appList"
        style="width: 100%">
        <el-table-column
          prop="group"
          :label="$t('agentManage.group')">
        </el-table-column>
        <el-table-column
          prop="appName"
          :label="$t('agentManage.appName')">
        </el-table-column>
        <el-table-column
          prop="open"
          :label="$t('agentManage.status')">
        </el-table-column>
        <el-table-column
          prop="serverPath"
          :show-overflow-tooltip="true"
          :label="$t('agentManage.serverPath')">
        </el-table-column>
      </el-table>
      <div class="dia-title" v-text="$t('agentManage.logCollect')"></div>
      <table class="t-table">
        <thead>
          <tr>
            <th class="t-border" v-text="$t('agentManage.group')"></th>
            <th class="t-border" v-text="$t('agentManage.appName')"></th>
            <th class="t-border" v-text="$t('agentManage.logPath')"></th>
            <th class="t-border" v-text="$t('agentManage.logFile')"></th>
            <th class="t-border t-border__min" v-text="$t('agentManage.uploadFreq')"></th>
            <th class="t-border t-border__min" v-text="$t('agentManage.monitorInterval')"></th>
            <th class="t-border t-border__none">
              <el-button type="primary" @click="addLog" v-text="$t('common.add')"></el-button>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in logList" :key="'key' + index">
            <td class="t-border">
              <g-select v-model="item.group" :list="select_group" @change="groupChange(item, index)"></g-select>
            </td>
            <td class="t-border">
              <g-select v-model="item.appName" :list="item.select_app"></g-select>
            </td>
            <td class="t-border">
              <el-input v-model="item.logPath"></el-input>
            </td>
            <td class="t-border">
              <el-input v-model="item.logFile"></el-input>
            </td>
            <td class="t-border t-border__min">
              <el-input v-model.number="item.uploadFreq"></el-input>
            </td>
            <td class="t-border t-border__min">
              <el-input v-model.number="item.monitorInterval"></el-input>
            </td>
            <td class="t-border t-border__none">
              <el-button type="primary" @click="deleteLog(index)" v-text="'--'" style="width: 62px;"></el-button>
            </td>
          </tr>
        </tbody>
      </table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="agentDiaVis = false" v-text="$t('common.close')"></el-button>
        <el-button type="primary" @click="saveLog" v-text="$t('common.save')"></el-button>
      </span>
    </el-dialog>
    <!-- 状态弹窗 -->
    <el-dialog
      :title="$t('agentManage.agentStatus')"
      :visible.sync="statusVisible"
      width="400px">
      <div>
        <el-form ref="statusForm" :model="statusForm" input-width="auto">
          <el-form-item :label="'IP'">
            <span v-text="statusForm.ip"></span>
          </el-form-item>
          <el-form-item :label="'Zookeeper'">
            <span v-text="statusForm.addr"></span>
          </el-form-item>
          <el-form-item :label="'s3.regionName'">
            <span v-text="statusForm.region"></span>
          </el-form-item>
          <el-form-item :label="'s3.bucketName'">
            <span v-text="statusForm.bucket"></span>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="statusVisible = false" v-text="$t('common.close')"></el-button>
      </span>
    </el-dialog>
    <!-- 克隆弹窗 -->
    <el-dialog :closeOnClickModal="false"
      :title="$t('agentManage.clone')" 
      :visible.sync="cloneDiaVis" 
      width="400px">
      <el-form ref="cloneForm" :model="cloneForm" label-width="60px" input-width="180px" :rules="cloneFormRule">
        <el-form-item :label="$t('agentManage.oriIP')">
          <span v-text="cloneForm.sourceIp"></span>
        </el-form-item>
        <el-form-item :label="$t('agentManage.targetIP')" prop="targetIp">
          <el-select
            v-model="cloneForm.targetIp"
            filterable
            :placeholder="$t('common.chooseTips')">
            <el-option
              v-for="item in ipList"
              :key="item.ip"
              :label="item.name"
              :value="item.ip">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="cloneDiaVis = false" v-text="$t('common.cancel')"></el-button>
        <el-button @click="confirmClone" v-text="$t('common.confirm')" type="primary"></el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import rac from '@/plugins/rac-mixin'
  import dic from '@/components/mixins/dic'
  import systemSettingBiz from '@/logic/systemSetting/systemSettingBiz'
  import staticConfigBiz from '@/logic/systemSetting/staticConfigBiz'
  import SiteListBiz from '@/logic/cmdb/cmdbBiz'
  import table from '@/components/mixins/table'
  import { extend } from '@/utils/tool'
  export default {
    mixins: [rac, dic, table],
    data () {
      return {
        tableControl: [
          {
            label: this.$t('agentManage.create'),
            callback: (row, index, data) => {
              this.agentDiaVis = true
              this.appList = []
              if (row.agentConfigs && row.agentConfigs.length > 0) {
                row.agentConfigs.map(item => {
                  let tempObj = { ...item }
                  tempObj.open = tempObj.open ? this.$t('agentManage.isOpen') : this.$t('agentManage.isNotOpen')
                  this.appList.push(tempObj)
                })
              }
              this.logList = []
              if (row.logFileConfigs && row.logFileConfigs.length > 0) {
                row.logFileConfigs.map(item => {
                  this.waitApp(item, false)
                })
              }
              this.selectIP = row.ip
            },
            rac: () => this.gRac('agentManage_add')
          },
          {
            label: this.$t('agentManage.status'),
            callback: (row, index, data) => {
              if (row.message) {
                this.statusForm = { ...row.message }
                this.statusVisible = true
              } else {
                this.$message({
                  message: this.$t('common.noData'),
                  type: 'warning'
                })
              }
            },
            rac: () => this.gRac('agentManage_status')
          },
          {
            label: this.$t('agentManage.clone'),
            callback: (row, index, data) => {
              this.cloneDiaVis = true
              this.cloneForm.sourceIp = row.ip
              this.cloneForm.targetIp = ''
              this.$nextTick(() => {
                this.$refs.cloneForm.clearValidate()
              })
            },
            rac: () => this.gRac('agentManage_clone')
          }
        ],
        select_group: {},
        select_site: {},
        select_app: {},
        select_status: {
          '1': this.$t('agentManage.online'),
          '2': this.$t('agentManage.offline'),
          '0': this.$t('agentManage.none')
        },
        searchForm: {
          group: '',
          siteCode: '',
          ip: '',
          status: ''
        },
        statusForm: {
          ip: '',
          addr: '',
          region: '',
          bucket: ''
        },
        cloneForm: {
          sourceIp: '',
          targetIp: ''
        },
        cloneFormRule: {
          targetIp: [
            { required: true, message: this.$t('agentManage.targetIPTips') }
          ]
        },
        agentDiaVis: false,
        statusVisible: false,
        appList: [],
        logList: [],
        selectIP: '',
        ipList: [],
        cloneDiaVis: false
      }
    },
    methods: {
      async waitGroupList (siteCode, siteChange, dialog) {
        await this.dGetGroup(siteCode, siteChange)
        this.select_group = this.$store.state.dicModule.group
      },
      getIPList () {
        staticConfigBiz.getHostIps().then((data) => {
          this.ipList = []
          data.map(item => {
            this.ipList.push({
              ip: item,
              name: item
            })
          })
        })
      },
      getSiteList () {
        SiteListBiz.siteList({ perPageCount: 500 }).then((data) => {
          let list = {}
          data.dataList.map((item) => {
            list[item.siteCode] = item.name
          })
          this.select_site = list
          this.waitGroupList()
        })
      },
      async waitApp (item, init = true, index) {
        await this.dGetAppByGroup('', item.group)
        if (index === 0 || index) {
          this.logList[index].select_app = { ...this.dDictionaryApp[item.group] }
          this.logList[index].appName = Object.keys(this.logList[index].select_app)[0]
          return
        } else {
          item.select_app = { ...this.dDictionaryApp[item.group] }
        }
        if (init) item.appName = Object.keys(item.select_app)[0]
        this.logList.push({ ...item })
      },
      initTable () {
        this.tInitTable({
          lanKey: 'agentManage.table',
          head: ['group', 'ip', 'status', 'version'],
          requestFun: this.searchTable,
          headOpt: {
            status: {
              formatter: 'Dictionary',
              formatterDic: this.select_status
            }
          }
        })
      },
      search () {
        this.tResetPage()
        this.searchTable()
      },
      searchTable () {
        let obj = {}
        for (let i in this.searchForm) {
          if (this.searchForm[i]) obj[i] = this.searchForm[i]
        }
        const reqData = extend(true, { ...this.tPageInfo }, obj)
        systemSettingBiz.getAgent(reqData).then((data) => {
          this.tData = data
        })
      },
      groupChange (item, index) {
        this.waitApp(item, false, index)
      },
      addLog () {
        this.waitApp({
          group: Object.keys(this.select_group)[0],
          logPath: '',
          logFile: '',
          uploadFreq: '',
          monitorInterval: ''
        })
      },
      deleteLog (index) {
        this.logList.splice(index, 1)
      },
      saveLog () {
        let logList = []
        this.logList.map(item => {
          logList.push({
            uploadFreq: item.uploadFreq,
            logPath: item.logPath,
            logFile: item.logFile,
            group: item.group,
            appName: item.appName,
            monitorInterval: item.monitorInterval
          })
        })
        systemSettingBiz.saveConfigAgent({
          ip: this.selectIP,
          logFileConfigs: logList
        }).then(data => {
          this.$message({
            message: this.$t('common.success'),
            type: 'success'
          })
          this.agentDiaVis = false
          this.searchTable()
        })
      },
      confirmClone () {
        this.$refs['cloneForm'].validate((valid) => {
          if (valid) {
            systemSettingBiz.cloneIP(this.cloneForm).then(data => {
              this.$message({
                message: this.$t('common.success'),
                type: 'success'
              })
              this.cloneDiaVis = false
              this.searchTable()
            })
          } else {
            return false
          }
        })
      }
    },
    watch: {
      'searchForm.siteCode': function (val) {
        this.waitGroupList(val, true)
        this.searchForm.group = ''
      }
    },
    mounted () {
      this.getSiteList()
      this.getIPList()
      this.initTable()
      this.searchTable()
    }
  }
</script>

<style>
  .agentManage .dia-title {
    line-height: 36px;
    font-size: 14px;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.65);
  }
  .agentManage .t-border {
    height: 28px;
    width: 160px;
    padding: 0 4px;
    border: 1px solid #ddd;
    text-align: center;
    font-weight: normal;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .agentManage .t-border input {
    border: none;
    text-align: center;
  }
  .agentManage .t-border__min {
    width: 80px;
  }
  .agentManage .t-border__none {
    border: none;
    width: auto;
    padding: 0;
  }
  .agentManage .t-table {
    border-collapse: collapse;
    border-spacing: 0;
  }
</style>